
import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator'
import { namespace as baseInfoStore, GetterType as BaseInfoGetterType, BaseInfoState } from '~/store/modules/BaseInfo'
import IconGoogle from '~/components/icons/IconGoogle.vue'

import type { Theme } from '~/types/theme'

const BaseInfoStore = namespace(baseInfoStore)

@Component({
  components: {
    IconGoogle,
  },
})
export default class GoogleRatingLite extends Vue {
  @BaseInfoStore.Getter(BaseInfoGetterType.GOOGLE_RATING)
  googleRating!: BaseInfoState['google_rating']

  @Prop({ default: 'md', type: String })
  readonly size!: 'md' | 'lg' | 'sm'

  @Prop({ default: 'light', type: String })
  readonly theme!: Theme

  get iconSize (): number {
    switch (this.size) {
      case 'md':
        return this.$mqUtils.isMobile ? 18 : 24

      case 'lg':
        return 34

      case 'sm':
        return 18
    }
  }

  get rating (): number {
    return this.googleRating?.rating ?? 0
  }

  get reviews (): number {
    return this.googleRating?.reviews ?? 0
  }

  get ratingRounded (): number {
    return Math.ceil(this.rating)
  }
}
